import React, { useEffect, useState } from 'react';
import { NavBar } from '../components/sections/NavBar';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { TeenAddictionSection } from '../components/sections/TeenAddictionSection';
import { SleepCrisisSection } from '../components/sections/SleepCrisisSection';
import { ARPANSASection } from '../components/sections/ARPANSASection';
import { SketchyProductsSection } from '../components/sections/SketchyProductsSection';
import { WhyStickersSection } from '../components/sections/WhyStickersSection';
import { HowQShieldWorksSection } from '../components/sections/HowQShieldWorksSection';
import { ProofSection } from '../components/sections/ProofSection';
import { HesitationsSection } from '../components/sections/HesitationsSection';
import { WhatHappensNextSection } from '../components/sections/WhatHappensNextSection';
import { FinalTruthSection } from '../components/sections/FinalTruthSection';
import { FooterSection } from '../components/sections/FooterSection';
export function QShieldPage() {
  const [showBuyBtn, setShowBuyBtn] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.1
    });
    const revealEls = document.querySelectorAll('.reveal');
    revealEls.forEach(el => observer.observe(el));
    const handleScroll = () => {
      const howItWorksEl = document.getElementById('how-it-works');
      if (howItWorksEl) {
        const rect = howItWorksEl.getBoundingClientRect();
        setShowBuyBtn(rect.top <= window.innerHeight);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    // Check on mount in case already scrolled
    handleScroll();
    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <div className="min-h-screen w-full" style={{
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }} data-id="element-304">
      <NavBar data-id="element-305" />
      <main data-id="element-306">
        <HeroSection data-id="element-307" />
        <div className="reveal" data-id="element-308">
          <ProblemSection data-id="element-309" />
        </div>
        <div className="reveal" data-id="element-310">
          <TeenAddictionSection data-id="element-311" />
        </div>
        <div className="reveal" data-id="element-312">
          <SleepCrisisSection data-id="element-313" />
        </div>
        <div className="reveal" data-id="element-314">
          <ARPANSASection data-id="element-315" />
        </div>
        <div className="reveal" data-id="element-316">
          <SketchyProductsSection data-id="element-317" />
        </div>
        <div className="reveal" data-id="element-318">
          <WhyStickersSection data-id="element-319" />
        </div>
        <div className="reveal" data-id="element-320">
          <HowQShieldWorksSection data-id="element-321" />
        </div>
        <div className="reveal" data-id="element-322">
          <ProofSection data-id="element-323" />
        </div>
        <div className="reveal" data-id="element-324">
          <HesitationsSection data-id="element-325" />
        </div>
        <div className="reveal" data-id="element-326">
          <WhatHappensNextSection data-id="element-327" />
        </div>
        <div className="reveal" data-id="element-328">
          <FinalTruthSection data-id="element-329" />
        </div>
        <FooterSection data-id="element-330" />
      </main>

      {/* Sticky Buy Now Button */}
      <div style={{
      position: 'fixed',
      bottom: '28px',
      left: '50%',
      transform: `translateX(-50%) translateY(${showBuyBtn ? '0' : '80px'})`,
      opacity: showBuyBtn ? 1 : 0,
      transition: 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.3s ease',
      zIndex: 999,
      pointerEvents: showBuyBtn ? 'auto' : 'none'
    }} data-id="element-331">
        <a href="https://VitaleneHealth.com" target="_blank" rel="noopener noreferrer" style={{
        display: 'inline-block',
        padding: '14px 40px',
        fontSize: '15px',
        fontWeight: 700,
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        textDecoration: 'none',
        color: '#1B4F9E',
        backgroundColor: 'rgba(240, 247, 255, 0.25)',
        border: '2px solid #1B4F9E',
        borderRadius: '50px',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        boxShadow: '0 4px 24px rgba(27, 79, 158, 0.18), inset 0 1px 0 rgba(255,255,255,0.3)',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        cursor: 'pointer',
        whiteSpace: 'nowrap'
      }} onMouseEnter={e => {
        ;
        (e.currentTarget as HTMLAnchorElement).style.backgroundColor = 'rgba(27, 79, 158, 0.12)';
        (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 6px 32px rgba(27, 79, 158, 0.28), inset 0 1px 0 rgba(255,255,255,0.3)';
      }} onMouseLeave={e => {
        ;
        (e.currentTarget as HTMLAnchorElement).style.backgroundColor = 'rgba(240, 247, 255, 0.25)';
        (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 4px 24px rgba(27, 79, 158, 0.18), inset 0 1px 0 rgba(255,255,255,0.3)';
      }} data-id="element-332">
          🛒 Buy Now
        </a>
      </div>
    </div>;
}